import httpService from '../httpService';
import { ApiResponse } from '../../types/api';

export async function get<T>(url: string, params?: Record<string, any>): Promise<ApiResponse<T>> {
  const response = await httpService.get<ApiResponse<T>>(url, { params });
  return response.data;
}
